// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app_footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0px 15px;
}
.app_footer .footer_text_wrap ul {
  padding: 0px;
  list-style: none;
  display: flex;
  align-items: center;
  margin-bottom: 0px;
}
.app_footer .footer_text_wrap ul li {
  padding-right: 15px;
}
.app_footer .footer_text_wrap ul li a {
  text-decoration: none;
  font-weight: 500;
  font-size: 12px;
  color: var(--text-color);
}
.app_footer .footer_icn_wrap ul {
  padding: 0px;
  list-style: none;
  display: flex;
  align-items: center;
}
.app_footer .footer_icn_wrap ul li {
  padding-left: 15px;
}
.app_footer .footer_icn_wrap ul li a {
  color: #3b5998;
  font-size: 20px;
}
.app_footer .footer_icn_wrap ul li:nth-child(2) a {
  color: #00acee !important;
}
.app_footer .footer_icn_wrap ul li:nth-child(3) a {
  color: #0A66C2 !important;
}
.app_footer .footer_icn_wrap ul li:nth-child(4) a {
  color: #57F287 !important;
}`, "",{"version":3,"sources":["webpack://./src/assets/style/common/footer.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,iBAAA;AACJ;AACQ;EACI,YAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AACZ;AACY;EACI,mBAAA;AAChB;AACgB;EACI,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,wBAAA;AACpB;AAMQ;EACI,YAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AAJZ;AAMY;EACI,kBAAA;AAJhB;AAMgB;EACI,cAAA;EACA,eAAA;AAJpB;AAOgB;EACI,yBAAA;AALpB;AAQgB;EACI,yBAAA;AANpB;AASgB;EACI,yBAAA;AAPpB","sourcesContent":[".app_footer {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    padding: 0px 15px;\n    .footer_text_wrap {\n        ul {\n            padding: 0px;\n            list-style: none;\n            display: flex;\n            align-items: center;\n            margin-bottom: 0px;\n\n            li {\n                padding-right: 15px;\n\n                a {\n                    text-decoration: none;\n                    font-weight: 500;\n                    font-size: 12px;\n                    color: var(--text-color);\n                }\n            }\n        }\n    }\n\n    .footer_icn_wrap {\n        ul {\n            padding: 0px;\n            list-style: none;\n            display: flex;\n            align-items: center;\n\n            li {\n                padding-left: 15px;\n\n                a {\n                    color: #3b5998;\n                    font-size: 20px;\n                }\n\n                &:nth-child(2) a {\n                    color: #00acee !important;\n                }\n\n                &:nth-child(3) a {\n                    color: #0A66C2 !important;\n                }\n\n                &:nth-child(4) a {\n                    color: #57F287 !important;\n                }\n            }\n\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
